import ReactOnRails from 'react-on-rails/client';
import PostsWidget from '../../app/PostsWidget.jsx';

ReactOnRails.register({PostsWidget});